import React, { useState, useEffect } from 'react';
import { ReadMoreButton, TextLines, ContentReadMoreButton } from './mixins';
const ReadMore = ({ readMore = 'Leer más', readLess = 'Leer menos', variant = 'primary', position = 'left', numberOfLines, id, children, }) => {
    const text = children;
    const [limitText, setLimitText] = useState(true);
    const [showLink, setShowLink] = useState(true);
    const toggleReadMore = () => {
        setLimitText(!limitText);
    };
    const showRead = element => {
        const heightLimit = 5;
        return element && element.scrollHeight - element.clientHeight >= heightLimit;
    };
    useEffect(() => {
        const element = document.getElementById(`${id}`);
        const isActive = showRead(element);
        setShowLink(isActive);
    }, [children, id]);
    return (React.createElement(React.Fragment, null,
        React.createElement(TextLines, { id: id, limitText: limitText, numberOfLines: numberOfLines }, text),
        React.createElement(ContentReadMoreButton, { position: position }, text && showLink && (React.createElement(ReadMoreButton, { buttonoptions: { variant: `${variant}`, size: 'small', type: 'link' }, onClick: toggleReadMore }, limitText ? readMore : readLess)))));
};
export default ReadMore;
